const stringToTimeFormat = (timeString: string) => {
  if (timeString) {
    const [time, ampm] = timeString.split(' ');

    const [hours, minutes] = time.split(':').map((part) => parseInt(part, 10));

    let hours24 = hours;
    if (ampm === 'PM' && hours !== 12) {
      hours24 += 12;
    } else if (ampm === 'AM' && hours === 12) {
      hours24 = 0;
    }

    const date = new Date();
    date.setHours(hours24, minutes, 0, 0);

    return date;
  }
  return null;
};

export default stringToTimeFormat;
